import request from '@/utils/request'

/* 登录 */
export function requestLogin(data) {
    return request({
        url: '/sso/v1/auth/token',
        method: 'post',
        data
    })
}
export function requestPhone(data) {
    return request({
        url: '/saas/crm/phone',
        method: 'get',
        params: data
    })
}
// 获取登录人信息
export function getInfo() {
    return request({
        url: '/account/v1/account/online',
        method: 'get'
    })
}

//菜单权限
export function requestMenuTree() {
    return request({
        url: '/account/v1/menu/crm/tree',
        method: 'get'
    })
}
//按钮权限
export function requestButtomAuth(data) {
    return request({
        url: '/account/v1/role/actAlias',
        method: 'get',
        params: data
    })
}

/* 首页 */
export function requestHome(data) {
    return request({
        url: '/saas/crm/index',
        method: 'get',
        params: data
    })
}
// 切换组织
export function changeCompany(data) {
    return request({
        url: '/sso/v1/auth/token/switch',
        method: 'get',
        params: data
    })
}

/* 租客 */
// 公司下拉
export function requestCompany(data) {
    return request({
        url: `/account/v1/company/current/list`,
        method: 'get',
        params: data
    })
}
// 客户详情
export function requestCustomerDetail(id) {
    return request({
        url: `/saas/v1/customer/crm/detail/${id}`,
        method: 'get'
    })
}
// 个人客户
export function requestCustomerPri(data) {
    return request({
        url: `/saas/v1/customer/crm/private/list/pages`,
        method: 'post',
        data
    })
}
// 公共客户
export function requestCustomerPub(data) {
    return request({
        url: `/saas/v1/customer/crm/public/list/pages`,
        method: 'post',
        data
    })
}
// 添加跟进
export function requestCustomerTrackrecord(data) {
    return request({
        url: `/saas/v1/customer/crm/add/trackrecord`,
        method: 'post',
        data
    })
}
// 抢单
export function requestCustomerGrap(id) {
    return request({
        url: `/saas/v1/customer/crm/grap/${id}`,
        method: 'get'
    })
}
// 获取客户
export function requestCustomerGet(id, storeId) {
    return request({
        url: `/saas/v1/customer/crm/acquire/${id}/${storeId}`,
        method: 'get'
    })
}
// 转让客户
export function requestCustomerTransfer(data) {
    return request({
        url: `/saas/v1/customer/crm/zr`,
        method: 'post',
        data
    })
}
// 强制转让客户
export function requestCustomerFTransfer(data) {
    return request({
        url: `/saas/v1/customer/crm/qzzr`,
        method: 'post',
        data
    })
}
// 手机号查重
export function requestPhoneRepeat(data) {
    return request({
        url: `/saas/v1/customer/channel/validate/${data}`,
        method: 'get'
    })
}
// 租客来源下拉
export function requestSourceList() {
    return request({
        url: `/saas/v1/source/list`,
        method: 'get'
    })
}
// 租房预算下拉
export function requestBudget(data) {
    return request({
        url: `/account/v1/config/budget/type`,
        method: 'get'
    })
}
// 门店下拉
export function requestPCStore(data) {
    return request({
        url: `/saas/v1/store/account`,
        method: 'get'
    })
}
// 公司下拉
export function requestPCCompany(data) {
    return request({
        url: `/account/v1/company/current/tenant`,
        method: 'get',
        params: data
    })
}
// 公司查门店
export function requestCompanyStore(data) {
    return request({
        url: `/saas/v1/store/company/${data}`,
        method: 'get'
    })
}
// 门店查管家
export function requestStoreOwner(data) {
    return request({
        url: `/account/v1/account/current/owner`,
        method: 'post',
        data
    })
}

// 添加跟进，状态下拉
export function requestFollowStatus(id) {
    return request({
        url: `/customer/${id}/status/list`,
        method: 'get',
    })
}
// 创建更新CRM租客信息
export function requestCustomerAdd(data) {
    return request({
        url: `/saas/v1/customer/createOrUpdate`,
        method: 'post',
        data
    })
}

/* 房源 */
// 房源详情（id）
export function requestHouseDetailId(id) {
    return request({
        url: `/saas/v1/house/${id}`,
        method: 'get'
    })
}
// 房间详情（id）
export function requestRoomDetailID(id) {
    return request({
        url: `/saas/v1/room/detail/${id}`,
        method: 'get'
    })
}

/* 下定 */
// 下定房源
export function requestDesHouseList(data) {
    return request({
        url: `/saas/v1/house/destine/list`,
        method: 'get',
        params: data
    })
}
// 下定客户
export function requestDesCustomerList(data) {
    return request({
        url: `/saas/v1/customer/like/phone`,
        method: 'get',
        params: data
    })
}
// 搜索入住人
export function requestCheckPersonList(data) {
    return request({
        url: `/saas/v1/customer/person/like/phone`,
        method: 'get',
        params: data
    })
}
// 新增预订单
export function requestDestineContractAdd(data) {
    return request({
        url: `/saas/v1/destineContract/create`,
        method: 'post',
        data
    })
}
// 获取预订单列表
export function requestDestineContract(data) {
    return request({
        url: `/saas/v1/destineContract/list/pages`,
        method: 'post',
        data
    })
}
// 获取预订单详情
export function requestDestineContractDetail(id) {
    return request({
        url: `/saas/v1/destineContract/${id}`,
        method: 'get'
    })
}
// 取消下定
export function requestDestineContractCancel(data) {
    return request({
        url: `/saas/v1/destineContract/cancel`,
        method: 'post',
        data
    })
}

/* 合约 */
// 租房合约列表
export function requestContractList(data) {
    return request({
        url: `/saas/v1/contract/list/pages`,
        method: 'post',
        data
    })
}
// 租房合约创建
export function requestContractCreate(data) {
    return request({
        url: `/saas/v1/contract/create`,
        method: 'post',
        data
    })
}
// 根据id租房合约详情
export function requestContractDetail(id) {
    return request({
        url: `/saas/v1/contract/${id}`,
        method: 'get'
    })
}
// 退租查合约详情
export function requestContractDetailReturn(id) {
    return request({
        url: `/saas/v1/returnOrder/detail/contract/${id}`,
        method: 'get'
    })
}
// 根据房源和租客查看租房合约详情
export function requestSaveContractDetail(data) {
    return request({
        url: `/saas/v1/contract/check/contract`,
        method: 'post',
        data
    })
}
// 重签根据老合约id查看合约详情
export function requestResignContractDetail(id) {
    return request({
        url: `/saas/v1/contract/resign/${id}`,
        method: 'get'
    })
}
// 租房查房源
export function requestHouseList(data) {
    return request({
        url: `/saas/v1/house/contract/list`,
        method: 'get',
        params: data
    })
}
// 获取房源整租合租信息
export function requestHouseType(houseId, type) {
    return request({
        url: `/saas/v1/roomInfo/${houseId}`,
        method: 'get',
        params: { contractType: type }
    })
}
// 查询sku套餐价格明细
export function requestSkuPrice(data) {
    return request({
        url: `/saas/v1/priceSku/item/price`,
        method: 'get',
        params: data
    })
}
// 分散式业主合约详情
export function requestFContractDetail(houseId, data) {
    return request({
        url: `/saas/v1/propertyContract/rent/startDate/${houseId}`,
        method: 'get',
        params: data
    })
}
// 集中式业主合约详情
export function requestJContractDetail(contractId) {
    return request({
        url: `/saas/v1/community/contract/detail/${contractId}`,
        method: 'get'
    })
}
// 租房合约，项目的费用项
export function requestMatterZX(data) {
    return request({
        url: `/saas/v1/matter/contract/list`,
        method: 'get',
        params: data
    })
}
// 获取七牛token
export function requestQiniuToken(data) {
    return request({
        url: `/saas/v1/qiniu/token`,
        method: 'get',
        params: data
    })
}
// 房间下定转签约验证
export function requestContractValid(id) {
    return request({
        url: `/saas/v1/destineContract/check/${id}`,
        method: 'get'
    })
}
// 租房合约作废
export function requestContractCancel(id, data) {
    return request({
        url: `/saas/v1/contract/cancel/${id}`,
        method: 'get',
        params: data
    })
}
// 租房合约单个提交
export function requestContractSubmit(id) {
    return request({
        url: `/saas/v1/contract/submit/${id}`,
        method: 'get'
    })
}
// 换转续根据合约ID校验是否存在有效退租单，生效账单是否全部支付
export function requestCValidHZX(contractId, type) {
    return request({
        url: `/saas/v1/contract/verity/hzx/${contractId}/${type}`,
        method: 'get'
    })
}
//CA
export function requestContractCA(contractId) {
    return request({
        url: `/saas/v1/eQianBao/sign/${contractId}`,
        method: 'get'
    })
}
// fadada合约CA
export function requestContractFddCA(contractId) {
    return request({
        url: `/saas/v1/fadada/sign/${contractId}`,
        method: 'get'
    })
}
//合约下载
export function requestContractDownload(contractId) {
    return request({
        url: `/saas/v1/eQianBao/contract/download/${contractId}`,
        method: 'get'
    })
}
// fadada合约下载
// export function requestContractFddDownload(contractId) {
//     return request({
//         url: `/saas/v1/fadada/contract/download/${contractId}`,
//         method: 'get'
//     })
// }
// fadada租房合约下载
export function requestContractFddDownload(contractId) {
    return request({
        url: `/saas/v1/fadada/download/cc/${contractId}`,
        method: 'get'
    })
}
//合约下载（钉钉）
export function requestContractDownloadDD(contractId) {
    return request({
        url: `/saas/v1/eQianBao/contract/download/dingding/${contractId}`,
        method: 'get'
    })
}
// 资产详情
export function requestAssetsDetail(id) {
    return request({
        url: `/saas/v1/material/${id}`,
        method: 'get'
    })
}
// 计算物业费
export function requestPropertyFee(data) {
    return request({
        url: `/saas/v1/calculate/propertyFee`,
        method: 'post',
        data
    })
}
// 根据开始时间和结束时间计算租期
export function requestLease(data) {
    return request({
        url: `/saas/v1/contract/calculate/period`,
        method: 'post',
        data
    })
}

/* 房间 */
// 房间分页
export function requestRoomList(data) {
    return request({
        url: `/saas/v1/crm/room/pages`,
        method: 'post',
        data
    })
}
//房间详情
export function requestRoomDetail(id) {
    return request({
        url: `/saas/v1/crm/room/detail/${id}`,
        method: 'get'
    })
}



// 审批流程详情
export function requestWorkflowDetail(data) {
    return request({
        url: `/workflow/v1/historyOrder/latest/flowChart`,
        method: 'get',
        params: data
    })
}
// 代办流程详情
export function requestWorkflowDetail1(data) {
    return request({
        url: `/workflow/v1/historyOrder/${data}/flowChart`,
        method: 'get'
    })
}
// 我发起的
export function requestWorkflowCurrent(data) {
    return request({
        url: `/workflow/v1/agentList/current/employee`,
        method: 'post',
        data
    })
}
// 待审批
export function requestWorkflowWait(data) {
    return request({
        url: `/workflow/v1/agentList/waiting/approval`,
        method: 'post',
        data
    })
}
// 参与
export function requestWorkflowInvolved(data) {
    return request({
        url: `/workflow/v1/agentList/involved`,
        method: 'post',
        data
    })
}
// 提交审批
export function requestWorkflowSubmit(data) {
    return request({
        url: `/workflow/v1/runtime/complete`,
        method: 'post',
        data
    })
}
// 接单
export function requestReceiveTransfer(id) {
    return request({
        url: `/saas/v1/customer/crm/receive/${id}`,
        method: 'get'
    })
}

// 所有跟踪记录状态
export function requestAllStatus(data) {
    return request({
        url: `/saas/v1/trackRecord/status/all`,
        method: 'get',
        params: data
    })
}
// 查询下级状态
export function requestChildStatus(data) {
    return request({
        url: `/saas/v1/trackRecord/extend/status`,
        method: 'get',
        params: data
    })
}
// 首页状态下拉
export function requestCustomerStatus(data) {
    return request({
        url: `/saas/v1/customer/status/all`,
        method: 'get',
        params: data
    })
}
// 代办类型下拉
export function requestAgentType(id) {
    return request({
        url: `/account/v1/config/agent/type`,
        method: 'get'
    })
}
// 当前处理人下拉
export function requestChargeList(accountId) {
    return request({
        url: `/account/v1/account/own/charge/${accountId}`,
        method: 'get'
    })
}

/* 账单 */
export function requestOrderList(data) {
    return request({
        url: `/saas/v1/order/crm/order/page`,
        method: 'post',
        data
    })
}

/* 退租 */
// 账号模糊查询
export function requestReceiptList(data, customerId) {
    return request({
        url: `/saas/v1/customerReceipt/info/${customerId}`,
        method: 'get',
        params: data
    })
}
// 退租单新增修改
export function requestReturnAdd(data) {
    return request({
        url: `/saas/v1/returnOrder/create`,
        method: 'post',
        data
    })
}
// 退租单详情
export function requestCReturnDetail(data) {
    return request({
        url: `/saas/v1/returnOrder/${data}`,
        method: 'get'
    })
}
// 退租单单个提交
export function requestReturnSubmit(data) {
    return request({
        url: `/saas/v1/returnOrder/submit/${data}`,
        method: 'get'
    })
}
//校验退租单提交
export function requestSubmitValid(id) {
    return request({
        url: `/saas/v1/returnOrder/${id}/check/item`,
        method: 'get'
    })
}
//是否发送退租保洁
export function requestWorkOrderISClean(data) {
    return request({
        url: `/saas/v1/returnOrder/clean`,
        method: 'post',
        data
    })
}
//退租单刷新
export function requestSubmitRefresh(id) {
    return request({
        url: `/saas/v1/returnOrder/${id}/refresh/item`,
        method: 'get'
    })
}
// 退租单作废
export function requestReturnCancel(id) {
    return request({
        url: `/saas/v1/returnOrder/cancel/${id}`,
        method: 'GET'
    })
}
// 退租单去签署
export function requestReturnOrderCa(returnOrderId, type) {
    return request({
        url: `/saas/v1/fadada/sign/ro/${returnOrderId}/${type}`,
        method: 'get'
    })
}
// 退租单合约下载
export function requestReturnOrderDownLoad(id) {
    return request({
        url: `/saas/v1/fadada/download/ro/${id}`,
        method: 'get'
    })
}
// 事项
export function requestOrderItems(data) {
    return request({
        url: `/saas/v1/returnOrder/auto/calculate`,
        method: 'post',
        data
    })
}
// 事项下拉
export function requestMatter(data) {
    return request({
        url: `/saas/v1/matter/list`,
        method: 'get'
    })
}
// 查当前登录人公司所属门店
export function requestNowStore(data) {
    return request({
        url: `/saas/v1/store/current/company`,
        method: 'get',
        params: data
    })
}
// 公司查启用员工（管家过滤）
export function requestCompanyOwner(data) {
    return request({
        url: `/account/v1/account/current/owner`,
        method: 'post',
        data
    })
}
// 申请详情
export function requestApplyDetail(id) {
    return request({
        url: `/saas/v1/bizApply/detail/${id}`,
        method: 'get'
    })
}
// 换房申请更新接收人
export function requestApplyTransfer(data) {
    return request({
        url: `/saas/v1/contract/change/house/agent`,
        method: 'post',
        data
    })
}

// 费用类型（租房合约一次性费用）
export function requestExpensesContractS(data) {
    return request({
        url: `/saas/v1/matter/contract/single/list  `,
        method: 'get',
        params: data
    })
}
// 费用类型（租房合约周期性费用）
export function requestExpensesContractP(data) {
    return request({
        url: `/saas/v1/matter/contract/period/list`,
        method: 'get',
        params: data
    })
}
// 费用类型（退租应付）
export function requestExpensesReturnP(data) {
    return request({
        url: `/saas/v1/matter/return/pay/list`,
        method: 'get',
        params: data
    })
}
// 费用类型（退租应收）
export function requestExpensesReturnR(data) {
    return request({
        url: `/saas/v1/matter/return/receive/list`,
        method: 'get',
        params: data
    })
}

// 收款方式下拉
export function requestAccountSelect(customerId) {
    return request({
        url: `/saas/v1/customerReceipt/list/${customerId}`,
        method: 'get'
    })
}

//分散式收房合约详情
export function requestFssContractDetail(id) {
    return request({
        url: `/saas/v1/propertyContract/${id}`,
        method: 'get'
    })
}

//集中式收房合约详情
export function requestJzsContractDetail(id) {
    return request({
        url: `/saas/v1/community/contract/detail/${id}`,
        method: 'get'
    })
}

// 分散式退房详情
export function requestFssReturnDetail(id) {
    return request({
        url: `/saas/v1/propertyReturnOrder/${id}`,
        method: 'get'
    })
}

// 集中式退房单详情
export function requestJzsReturnDetail(id) {
    return request({
        url: `/saas/v1/communityReturnOrder/${id}`,
        method: 'get'
    })
}

//小区详情
export function requestCommunityDetail(id) {
    return request({
        url: `/saas/v1/community/${id}`,
        method: 'get'
    })
}

// 装修单详情
export function requestRemodelDetail(id) {
    return request({
        url: `/saas/v1/decoration/detail/${id}`,
        method: 'get'
    })
}


//代办详情
export function requestAgentDetail(id) {
    return request({
        url: `/workflow/v1/agentList/${id}`,
        method: 'get'
    })
}
/* 钉钉授权 */
export function requestDDConfig(data) {
    return request({
        url: `/saas/crm/get/auth/info`,
        method: 'get',
        params: data
    })
}
/* 业主列表分页 */
export function requestPropertyList(data) {
    return request({
        url: `/saas/v1/property/crm/list/pages`,
        method: 'get',
        params: data
    })
}
/* 业主新增 */
export function requestPropertyCreate(data) {
    return request({
        url: `/saas/v1/property/create`,
        method: 'post',
        data
    })
}
/* 业主修改 */
export function requestPropertyChange(data) {
    return request({
        url: `/saas/v1/property/update`,
        method: 'put',
        data
    })
}
/* 业主详情 */
export function requestPropertyDetail(id) {
    return request({
        url: `/saas/v1/property/detail/${id}`,
        method: 'get'
    })
}
// 业主启用禁用
export function requestOwnerEnable(id, status) {
    return request({
        url: `/saas/v1/property/enable/${id}/${status}`,
        method: 'get'
    })
}
// 分散式收房合约分页
export function requestFssContractList(data) {
    return request({
        url: `/saas/v1/propertyContract/crm/list/pages`,
        method: 'get',
        params: data
    })
}
// 查询当前公司下待签约分散式房源列表
export function requestFssHouseList(data) {
    return request({
        url: `/saas/v1/house/waiting/sign/list`,
        method: 'get',
        params: data
    })
}
// 收房合约暂存
export function requestHouseContract(houseId) {
    return request({
        url: `/saas/v1/propertyContract/active/${houseId}`,
        method: 'get'
    })
}
// 收房合约续签
export function requestFssContractRenew(id) {
    return request({
        url: `/saas/v1/propertyContract/renew/${id}`,
        method: 'get'
    })
}
// 分散式合约提交
export function requestFssContractSubmit(id) {
    return request({
        url: `/saas/v1/propertyContract/submit/${id}`,
        method: 'get'
    })
}
// 分散式合约作废
export function requestFssContractCancel(id) {
    return request({
        url: `/saas/v1/propertyContract/cancel/${id}`,
        method: 'get'
    })
}
// 分散式合约CA
export function requestPContractCA(id) {
    return request({
        url: `/saas/v1/eQianBao/sign/pc/${id}`,
        method: 'get'
    })
}
// 分散式合约法大大CA
export function requestPContractFddCA(id) {
    return request({
        url: `/saas/v1/fadada/sign/pc/${id}`,
        method: 'get'
    })
}
// 分散式合约下载
export function requestPContractDownload(id) {
    return request({
        url: `/saas/v1/eQianBao/contract/download/pc/${id}`,
        method: 'get'
    })
}
// 分散式 fadada合约下载
export function requestPContractFddDownload(id) {
    return request({
        url: `/saas/v1/fadada/download/pc/${id}`,
        method: 'get'
    })
}
// 业主电话搜索
export function requestPhoneList(data) {
    return request({
        url: `/saas/v1/property/phone`,
        method: 'get',
        params: data
    })
}
//业主收款信息
export function requestPReceipt(data) {
    return request({
        url: `/saas/v1/property/receipt`,
        method: 'get',
        params: data
    })
}
// 收房合约新增
export function requestFssContractCreate(data) {
    return request({
        url: `/saas/v1/propertyContract/create`,
        method: 'post',
        data
    })
}
//业主收款账号
export function requestPReceiptList(data) {
    return request({
        url: `/saas/v1/property/receipt/info`,
        method: 'get',
        params: data
    })
}
// 分页查询物料
export function requestMaterialList(data) {
    return request({
        url: `/saas/v1/material/list/pages`,
        method: 'post',
        data
    })
}
// 物料品类树
export function requestMaterialTypeTree(data) {
    return request({
        url: `/saas/v1/materialType/tree`,
        method: 'get',
        params: data
    })
}
// 根据一级品类查二级品类
export function requestMaterialChild(id) {
    return request({
        url: `/saas/v1/materialType/child/${id}`,
        method: 'get'
    })
}
// 根据二级品类查规格
export function requestMaterialChild3(id) {
    return request({
        url: `/saas/v1/material/specification/${id}`,
        method: 'get'
    })
}
// 开户行下拉
export function requestBankSelect() {
    return request({
        url: `/saas/v1/bank/list`,
        method: 'get',

    })
}
//工单分页
export function requestWorkOrderList(data) {
    return request({
        url: `/saas/v1/workOrder/crm/pages`,
        method: 'post',
        data
    })
}
//工单状态统计
export function requestWorkOrderStatus(data) {
    return request({
        url: `/saas/v1/workOrder/crm/statistics`,
        method: 'post',
        data
    })
}
// 获取工单服务类型一级列表
export function requestServiceListOne() {
    return request({
        url: `/saas/v1/workOrder/serviceType/list/one`,
        method: 'get',
    })
}
// 根据一级获取下面二级和三级
export function requestServiceListLevel(parentId) {
    return request({
        url: `/saas/v1/workOrder/serviceType/list/children/${parentId}`,
        method: 'get',
    })
}
//工单创建
export function requestWorkOrderCreate(data) {
    return request({
        url: `/saas/v1/workOrder/create`,
        method: 'post',
        data
    })
}
//工单详情
export function requestWorkOrderDetail(id) {
    return request({
        url: `/saas/v1/workOrder/detail/${id}`,
        method: 'get'
    })
}
//查询工单客户
export function requestWorkOrderCustomer(data) {
    return request({
        url: `/saas/v1/workOrder/customer/list`,
        method: 'get',
        params: data
    })
}
//查询工单房源
export function requestWorkOrderHouse(data) {
    return request({
        url: `/saas/v1/house/workorder/list`,
        method: 'get',
        params: data
    })
}
//查询工单服务类型
export function requestWorkOrderServiceType(data) {
    return request({
        url: `/saas/v1/workOrder/service/type`,
        method: 'get',
        params: data
    })
}
//工单派单
export function requestWorkOrderPd(data) {
    return request({
        url: `/saas/v1/workOrder/pd`,
        method: 'post',
        data
    })
}
//工单转单
export function requestWorkOrderZd(data) {
    return request({
        url: `/saas/v1/workOrder/zd/${data.workOrderId}`,
        method: 'get',
        params: data
    })
}
//工单接单
export function requestWorkOrderJd(workOrderId) {
    return request({
        url: `/saas/v1/workOrder/receive/${workOrderId}`,
        method: 'get'
    })
}
//工单处理
export function requestWorkOrderCl(workOrderId) {
    return request({
        url: `/saas/v1/workOrder/handle/${workOrderId}`,
        method: 'get'
    })
}
//工单完成
export function requestWorkOrderFinish(data) {
    return request({
        url: `/saas/v1/workOrder/finish`,
        method: 'post',
        data
    })
}
//工单关闭
export function requestWorkOrderClose(data) {
    return request({
        url: `/saas/v1/workOrder/close`,
        method: 'post',
        data
    })
}
//工单添加备注
export function requestWorkOrderRemark(data) {
    return request({
        url: `/saas/v1/workOrder/add/remark/${data.id}`,
        method: 'get',
        params: data
    })
}
//工单查询人员
export function requestWorkOrderCustomerPd(data) {
    return request({
        url: `/saas/v1/workOrder/pd/customer/list`,
        method: 'get',
        params: data
    })
}
//添加协作人
export function requestWorkOrderCooperation(data) {
    return request({
        url: `/saas/v1/workOrder/add/cooperation`,
        method: 'post',
        data
    })
}
//删除协作人
export function requestWorkOrderCooperationD(data) {
    return request({
        url: `/saas/v1/workOrder/remove/cooperation`,
        method: 'get',
        params: data
    })
}
//工单常规保洁
export function requestWorkOrderClean(data) {
    return request({
        url: `/saas/v1/workOrder/common/clean`,
        method: 'get',
        params: data
    })
}
//工单根据房源查房间
export function requestWorkOrderHouseRoom(houseId) {
    return request({
        url: `/saas/v1/rooms/${houseId}`,
        method: 'get'
    })
}


//门锁
//门锁绑定
export function requestLockBind(number) {
    return request({
        url: `/saas/v1/lock/house/${number}/bind`,
        method: 'post',
    })
}
// 查询门锁异步消息记录
export function requestLockAsyncList(data) {
    return request({
        url: `/saas/v1/lock/event/list`,
        method: 'get',
        params: data
    })
}
//发送密码获取门锁、网关详情
export function requestLockInfo(houseId) {
    return request({
        url: `/saas/v1/lock/info`,
        method: 'get',
        params: { houseId: houseId }
    })
}
//发送密码
// export function requestLockPassword(data) {
//     return request({
//         url: `/saas/v1/lock/send/${data.type}/password`,
//         method: 'post',
//         data
//     })
// }
export function requestLockPassword(data) {
    return request({
        url: `/saas/v1/device/lock/send/password`,
        method: 'post',
        data
    })
}
//账期密码获取起止时间
export function requestLockKeytime(contractId) {
    return request({
        url: `/saas/v1/device/contract/order/time`,
        method: 'get',
        params: { contractId: contractId }
    })
}
//查询门锁密码下发记录
export function requestLockPage(data) {
    return request({
        url: `/saas/v1/lock/house/password/pages`,
        method: 'get',
        params: data
    })
}
//查询房间、房源门锁密码下发记录
export function requestLocklist(data) {
    return request({
        url: `/saas/v1/lock/home/password/pages`,
        method: 'get',
        params: data
    })
}
//查询房间、房源门锁异步消息记录
export function requestOtherLocklist(data) {
    return request({
        url: `/saas/v1/lock/event/tab/list`,
        method: 'get',
        params: data
    })
}
//刷新设备
export function requestLockRefresh(houseId) {
    return request({
        url: `/saas/v1/lock/refresh`,
        method: 'get',
        params: { houseId: houseId }
    })
}

// 报表房间信息
export function requestReportRoom(data) {
    return request({
        url: `/saas/v1/report/room/info`,
        method: 'get',
        params: data
    })
}
// 报表合约信息
export function requestReportContract(data) {
    return request({
        url: `/saas/v1/report/contract/info`,
        method: 'get',
        params: data
    })
}
// 报表退租单信息
export function requestReportReturnOrder(data) {
    return request({
        url: `/saas/v1/report/returnOrder/info`,
        method: 'get',
        params: data
    })
}
// 报表财务信息
export function requestReportFinancial(data) {
    return request({
        url: `/saas/v1/report/financial/info`,
        method: 'get',
        params: data
    })
}
// 报表工单信息
export function requestReportWorkOrder(data) {
    return request({
        url: `/saas/v1/report/workOrder/info`,
        method: 'get',
        params: data
    })
}
// 报表跟踪记录信息
export function requestReportTrackRecord(data) {
    return request({
        url: `/saas/v1/report/trackRecord/info`,
        method: 'get',
        params: data
    })
}
// 报表满租率统计
export function requestReportRate(data) {
    return request({
        url: `/saas/v1/report/rate/info`,
        method: 'get',
        params: data
    })
}
// 报表平均出租价格统计
export function requestReportAveragePrice(data) {
    return request({
        url: `/saas/v1/report/average/price/info`,
        method: 'get',
        params: data
    })
}

// A联单客户列表(私有)
export function requestJointOrderCustomerPri(data) {
    return request({
        url: `/saas/v1/ajocustomer/crm/private/list/pages`,
        method: 'post',
        data
    })
}
// A联单客户列表(公共)
export function requestJointOrderCustomerPub(data) {
    return request({
        url: `/saas/v1/ajocustomer/crm/public/list/pages`,
        method: 'post',
        data
    })
}
// A联单跟踪记录状态
export function requestjointOrderAllStatus(data) {
    return request({
        url: `/saas/v1/ajocustomer/status/all`,
        method: 'get',
        params: data
    })
}
// A联单新增客户
export function requestJointOrderCustomerAdd(data) {
    return request({
        url: `/saas/v1/ajocustomer/createOrUpdate`,
        method: 'post',
        data
    })
}
// 请求城市以及行政区划
export function requestCityList(data) {
    return request({
        url: `/saas/v1/ajocustomer/current/city`,
        method: 'get',
    })
}
// A联单手机号查重
export function requestJointOrderPhoneRepeat(data) {
    return request({
        url: `/saas/v1/ajocustomer/validate/${data}`,
        method: 'get'
    })
}
// A联单抢单验证
export function requestJointOrderGrabbing(data) {
    return request({
        url: `/saas/v1/ajocustomer/validatePhone`,
        method: 'get',
        params: {
            phone: data.phone,
            id: data.id
        }
    })
}
// A联单抢单
export function requestJointOrderCustomerGrap(id) {
    return request({
        url: `/saas/v1/ajocustomer/crm/grap/${id}`,
        method: 'get'
    })
}
// A联单详情
// /saas/v1/ajocustomer/crm/detail
export function requestJointOrderCustomerDetail(id) {
    return request({
        url: `/saas/v1/ajocustomer/crm/detail/${id}`,
        method: 'get'
    })
}
// A联单装修类型
// /saas/v1/ajocustomer/decoration/type/all
export function requestJointOrderDecorationType() {
    return request({
        url: `/saas/v1/ajocustomer/decoration/type/all`,
        method: 'get'
    })
}

//  A联单保存
export function requestJointOrderUpdate(data) {
    return request({
        url: `/saas/v1/ajocustomer/crm/survey/createOrUpdate`,
        method: 'post',
        data
    })
}
// A联单转让客户
export function requestJointOrderTransfer(data) {
    return request({
        url: `/saas/v1/ajocustomer/crm/zr`,
        method: 'post',
        data
    })
}
// A联单跟进记录
export function requestJointOrderTrackrecord(data) {
    return request({
        url: `/saas/v1/ajocustomer/crm/add/trackrecord`,
        method: 'post',
        data
    })
}

// A联单查询状态
export function requestJointOrderChildStatus(data) {
    return request({
        url: `/saas/v1/ajoTrackRecord/extend/status`,
        method: 'get',
        params: data
    })
}

// A联单公司查管家
export function requestJointOrderOwner(data) {
    return request({
        url: `/account/v1/account/current/company/owner`,
        method: 'post',
        data
    })
}
// A联单施工宝列表 
export function requestJointOrderConstructDetail(id) {
    return request({
        url: `/saas/v1/construct/customer/${id}`,
        method: 'post'
    })
}
// 收房合约施工宝列表
export function requestJointOrderContractConstructDetail(id) {
    return request({
        url: `/saas/v1/construct/contract/${id}`,
        method: 'get'
    })
}
// A联单施工宝最新列表数据 /saas/v1/construct/lately
export function requestJointOrderConstructDetailLast(id) {
    return request({
        url: `/saas/v1/construct/lately/${id}`,
        method: 'get'
    })
}
export function requestJointOrderConstructSaveOrUpdate(data) {
    return request({
        url: `/saas/v1/construct/customer/saveOrUpdate`,
        method: 'post',
        data
    })
}
// 查询分散式小区
export function requestCommunitySearch(data) {
    return request({
        url: `/saas/v1/community/all`,
        method: 'get',
        params: data
    })
}
// 获取定价宝下拉（小区）
export function requestFixPriceSelect(data) {
    return request({
        url: `/saas/v1/priceModel/list`,
        method: 'get'
    })
}
export function requestCreatePrice(data) {
    return request({
        url: `/saas/v1/ajocustomer/crm/computePrice`,
        method: 'post',
        data
    })
}
// 提交实勘信息
export function requestJointOrderSubmit(id) {
    return request({
        url: `/saas/v1/ajocustomer/submit/${id}`,
        method: 'get'
    })
}

// 请求预缴费规则
export function requestParameterRules() {
    return request({
        url: `/saas/v1/bizConfig/type/1`,
        method: 'get'
    })
}
// 新增房源校验
export function requestValidHouse(data) {
    return request({
        url: `/saas/v1/house/verify`,
        method: 'post',
        data
    })
}
// 请求托管规则
export function requestDepositRules() {
    return request({
        url: `/saas/v1/bizConfig/type/2`,
        method: 'get'
    })
}
// 跟踪记录汇总 公司筛选
export function requestTraceRecord() {
    return request({
        url: `/account/v1/company/show/report/all`,
        method: 'get',
    })
}
// 跟踪记录汇总 报表管理运营汇总 

export function requestReportTrackRecordAll(data) {
    return request({
        url: `/saas/v1/report/trackRecord/item/info`,
        method: 'get',
        params: data
    })
}
// 续约配置资产信息 
export function requestUnuseAssetsIdList(houseId) {
    return request({
        url: `/saas/v1/house/material/assets/${houseId}`,
        method: 'get'
    })
}

//上传委托书
export function requestLoeAttorney(data) {
    return request({
        url: `/saas/v1/propertyContract/update/attorney/pictures`,
        method: 'post',
        data
    })
}
// 上传盖章页
export function requestUploadStamp(data) {
    return request({
        url: `/saas/v1/contract/update/stampe/pictures`,
        method: 'post',
        data
    })
}
// 签署校验
export function requestValidSignCheck(id) {
    return request({
        url: `/saas/v1/contract/sign/check/${id}`,
        method: 'get'
    })
}
// 根据房源判断绑定关系是否存在 水表

export function requestHouseWaterExist(houseId, checkRoom) {
    return request({
        url: `/saas/v1/device/check/bind/exists/water/house/${houseId}/${checkRoom}`,
        method: 'get',
    })
}

// 根据房源判断绑定关系是否存在 电表

export function requestHouseElectronicExist(houseId, checkRoom) {
    return request({
        url: `/saas/v1/device/check/bind/exists/electronic/house/${houseId}/${checkRoom}`,
        method: 'get',
    })
}

// 根据合约判断绑定关系是否正确 水表

export function requestContractWaterIsRight(contractId, checkRoom) {
    return request({
        url: `/saas/v1/device/check/bind/water/contract/${contractId}/${checkRoom}`,
        method: 'get',
    })
}

// 根据合约判断绑定关系是否正确 电表

export function requestContractElectronicIsRight(contractId, checkRoom) {
    return request({
        url: `/saas/v1/device/check/bind/electronic/contract/${contractId}/${checkRoom}`,
        method: 'get',
    })
}

// 根据房源判断绑定关系是否正确 水表

export function requestHouseWaterIsRight(houseId, checkRoom) {
    return request({
        url: `/saas/v1/device/check/bind/water/house/${houseId}/${checkRoom}`,
        method: 'get',
    })
}

// 根据房源判断绑定关系是否正确 电表

export function requestHouseElectronicIsRight(houseId, checkRoom) {
    return request({
        url: `/saas/v1/device/check/bind/electronic/house/${houseId}/${checkRoom}`,
        method: 'get',
    })
}

// 校验房源当天有没有结算水电费
export function requestHouseSettlement(contractId) {
    return request({
        url: `/saas/v1/device/check/calculate/${contractId}`,
        method: 'get',
    })
}
// 手动结算水电费
export function requestGoSettlement(houseId) {
    return request({
        url: `/saas/v1/device/auto/calculate/${houseId}`,
        method: 'get',
    })
}
// 根据房源校验设备是否在线
export function requestHouseDeviceIsOnOff(houseId, checkRoom) {
    return request({
        url: `/saas/v1/device/check/device/onoff/house/${houseId}/${checkRoom}`,
        method: 'get',
    })
}

// 智能设备抄表记录
export function requestDeviceList(id) {
    return request({
        url: `/saas/v1/roomMeter/device/list/${id}`,
        method: 'get',
    })
}
export function requestUpdateDevice(data) {
    return request({
        url: `/saas/v1/roomMeter/device/save`,
        method: 'post',
        data
    })
}
// 设备类型列表：/v1/device/type/list
export function requestDeviceTypeList() {
    return request({
        url: `/saas/v1/device/type/list`,
        method: 'get',
    })
}

// 房源详情 获取该房源所有设备
export function requsetDeviceListDetail(data) {
    return request({
        url: `/saas/v1/device/list/house/${data.houseId}?roomId=${data.roomId}`,
        method: 'get',
    })
}
// 设备详情
export function requsetDeviceDetail(id) {
    return request({
        url: `/saas/v1/device/detail/${id}`,
        method: 'get',
    })
}
// 合约详情 获取该房源所有设备
export function requsetDeviceListDetailContract(id) {
    return request({
        url: `/saas/v1/device/list/contract/${id}`,
        method: 'get',
    })
}
// 换绑搜索接口
export function requestDeviceSearchList(type, data) {
    return request({
        url: `/saas/v1/device/unbind/list/${type}?search=${data}`,
        method: 'get',
    })
}

// 换绑保存
export function requestChangeDeviceSave(data) {
    return request({
        url: `/saas/v1/device/changeBind/${data.id}/${data.newId}`,
        method: 'get',
    })
}
// 抄表
export function requestDeviceReading(data) {
    return request({
        url: `/saas/v1/device/reading`,
        method: 'post',
        data
    })
}
// 财务管理 消费记录
export function requestconsumeRecordList(data) {
    return request({
        url: `/saas/v1/device/consume/list/pages`,
        method: 'post',
        data
    })
}

// 合约请求活动列表
export function requestContractActivityList(data) {
    return request({
        url: `/saas/v1/activity/contract/list`,
        method: 'get',
        params: data
    })
}
// 电表刷新
export function requestEleRefresh(id) {
    return request({
        url: `/saas/v1/contract/refresh/ele/${id}`,
        method: 'get',
    })
}
// 设备详情刷新
export function requestDeviceRefresh(uuid) {
    return request({
        url: `/saas/v1/device/refresh/${uuid}`,
        method: 'get'
    })
}
// 退租单去签校验
export function requestReturnOrderCaCheck(returnOrderId) {
    return request({
        url: `/saas/v1/fadada/sign/ro/check/${returnOrderId}`,
        method: 'get'
    })
}
// 撤销退租单签署
export function requestReturnRecallCa(id) {
    return request({
        url: `/saas/v1/fadada/returnOrder/recall/${id}  `,
        method: 'get'
    })
}

// 合约列表获取问卷列表
export function requestContractQuestionList(type) {
    return request({
        url: `/saas/v1/question/company/list/${type}`,
        method: 'get',
    })
}
// 发送问卷
export function requestContractQuestionSave(data) {
    return request({
        url: `/saas/v1/question/qustionContract/send/${data.contractId}/${data.questionCompanyId}`,
        method: 'post'
    })
}